import React, { useState, useMemo, useEffect } from "react";
import axios from "axios";
import { FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import itemImg from "../../../Assets/items.png";
import "./ItemsList.css";

const ItemsPage = () => {
  const API = "https://fliplyn-b-c.fly.dev";

  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Get data from navigation
  const stall_id = location.state?.stall_id;
  const stall = location.state?.stall;
  const selectedCategoryObj = location.state?.category;

  const category_id = selectedCategoryObj?.id;
  const admin_id = selectedCategoryObj?.admin_id; // ✅ NEW

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  console.log("📦 CATEGORY RECEIVED:", selectedCategoryObj);
  console.log("🆔 CATEGORY ID:", category_id);
  console.log("👨‍💻 ADMIN ID:", admin_id); // ✅ DEBUG

  // ✅ Fetch items
  useEffect(() => {
    if (!stall_id) return;

    const fetchItems = async () => {
      try {
        let url = `${API}/items/stall/${stall_id}`;

        // ✅ If category exists → filter API
        if (category_id) {
          url = `${API}/items/category/${category_id}`;
        }

        const res = await axios.get(url);
        setItems(res.data);

        console.log("🟢 ITEMS LOADED:", res.data);
      } catch (error) {
        console.error("❌ Error fetching items:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, [stall_id, category_id]);

  // ✅ Search filter
  const filteredItems = useMemo(() => {
    return items.filter((item) =>
      item.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [items, search]);

  if (!stall_id) {
    return <h2 style={{ textAlign: "center" }}>Stall not found</h2>;
  }

  if (loading) {
    return <h2 style={{ textAlign: "center" }}>Loading...</h2>;
  }

  return (
    <div className="items-container-admin">
      {/* Header */}
      <div className="top-card">
        <div className="outlet-info-items">
          <img
            src={stall?.image_url || "https://via.placeholder.com/80"}
            alt="outlet"
            className="outlet-img"
          />

          <div className="outlet-details-in-items">
            <h2>{stall?.name}</h2>

            {selectedCategoryObj && (
              <p style={{ color: "#666" }}>
                Category: <b>{selectedCategoryObj.name}</b>
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Title */}
      <h1 className="items-title">
        {selectedCategoryObj ? selectedCategoryObj.name : "All Items"}
      </h1>

      {/* Filters */}
      <div className="filters">
        <div className="search-box">
          <FaSearch />
          <input
            type="text"
            placeholder="Search items"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* CREATE ITEM BUTTON */}
        <button
          className="create-item-btn"
          onClick={() =>
            navigate("/create-item", {
              state: {
                stall_id,
                category_id,
                admin_id, // ✅ PASS ADMIN ID
                category: selectedCategoryObj,
                stall,
              },
            })
          }
        >
          + Create Item
        </button>
      </div>

      {/* Table */}
      <table className="items-table">
        <thead>
          <tr>
            <th>Item Name</th>
            <th>Price</th>
            <th>Available</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <tr key={item.id}>
                <td className="item-details">
                  <img
                    src={
                      item.image_url && item.image_url.trim() !== ""
                        ? item.image_url
                        : itemImg
                    }
                    alt="food"
                  />
                  <div>
                    <strong>{item.name}</strong>
                  </div>
                </td>

                <td>₹ {item.final_price}</td>

                <td>
                  {item.is_available ? "✅ Available" : "❌ Not Available"}
                </td>

                <td className="actions">
                  <FaEdit />
                  <FaTrash />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                No items found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ItemsPage;